// extracted by mini-css-extract-plugin
export default {"root":"ClientPanelHeader_root__YfAxx","title":"ClientPanelHeader_title__ZrypA","text":"ClientPanelHeader_text__fbpbM"};